<template>
    <div class="ml-auto mr-0">
      <button
        class="bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold py-1.5 px-3 rounded "
        @click="openModal"
      >
        {{ uiT('company.button') }}
      </button>
  
      <div v-if="open" class="fixed inset-0 z-[100] flex items-center justify-center">
        <!-- backdrop -->
        <div class="absolute inset-0 bg-black/30" @click="close"></div>
  
        <!-- modal -->
        <div class="relative bg-white w-[min(680px,92vw)] max-h-[85vh] overflow-auto rounded-2xl shadow-2xl p-5">
          <button class="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-100" @click="close" :aria-label="uiT('common.close')">
            ✕
          </button>
  
          <h3 class="text-lg font-bold mb-4">{{ uiT('company.detailTitle') }}</h3>
  
          <div v-if="loading" class="py-10 text-center text-gray-500">{{ uiT('common.loading') }}</div>
  
          <form v-else @submit.prevent="confirmSave">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.idType') }}</label>
                <select v-model="form.tipo_identificacion" class="w-full border rounded px-3 py-2">
                  <option :value="null">—</option>
                  <option value="CC">CC</option>
                  <option value="NIT">NIT</option>
                  <option value="PASAPORTE">PASAPORTE</option>
                  <option value="RUC">RUC</option>
                </select>
              </div>
  
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.idNumber') }}</label>
                <input v-model="form.numero_identificacion" class="w-full border rounded px-3 py-2" />
              </div>
  
              <div class="md:col-span-2">
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.businessName') }}</label>
                <input v-model="form.razon_social" class="w-full border rounded px-3 py-2" />
              </div>
  
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.country') }}</label>
                <input v-model="form.pais" class="w-full border rounded px-3 py-2" />
              </div>
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.city') }}</label>
                <input v-model="form.ciudad" class="w-full border rounded px-3 py-2" />
              </div>
  
              <div class="md:col-span-2">
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.address') }}</label>
                <input v-model="form.direccion" class="w-full border rounded px-3 py-2" />
              </div>
  
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.phone') }}</label>
                <input v-model="form.telefono" class="w-full border rounded px-3 py-2" />
              </div>
              
  
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.currency') }}</label>
                <input v-model="form.moneda" class="w-full border rounded px-3 py-2" placeholder="COP, USD, ..." />
              </div>
  
              <div class="md:col-span-2">
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('company.website') }}</label>
                <input v-model="form.pagina_web" class="w-full border rounded px-3 py-2" />
              </div>
  
              <div class="md:col-span-2 pt-2">
                <div class="text-sm font-semibold text-gray-700 mb-1">{{ uiT('company.legalRepresentative') }}</div>
              </div>
  
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('registration.name') }}</label>
                <input v-model="form.nombre_representante_legal" class="w-full border rounded px-3 py-2" />
              </div>
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('registration.phone') }}</label>
                <input v-model="form.celular" class="w-full border rounded px-3 py-2" />
              </div>
  
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('registration.email') }}</label>
                <input v-model="form.correo_electronico" type="email" class="w-full border rounded px-3 py-2" />
              </div>
              <div>
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('registration.identification') }}</label>
                <input v-model="form.identificacion_representante_legal" class="w-full border rounded px-3 py-2" />
              </div>
              <div class="md:col-span-2">
                <label class="block text-sm text-gray-600 mb-1">{{ uiT('registration.position') }}</label>
                <input v-model="form.cargo_representante_legal" class="w-full border rounded px-3 py-2" />
              </div>
            </div>
  
            <div class="mt-6 flex justify-end gap-3">
              <button type="button" class="px-4 py-2 rounded border" @click="close">{{ uiT('common.cancel') }}</button>
              <button type="submit" class="px-4 py-2 rounded bg-blue-600 text-white font-semibold">{{ uiT('common.save') }}</button>
            </div>
          </form>
        </div>
      </div>
  
      <!-- Confirmación simple -->
      <div v-if="confirming" class="fixed inset-0 z-[110] flex items-center justify-center">
        <div class="absolute inset-0 bg-black/30" @click="confirming=false"></div>
        <div class="relative bg-white w-[min(420px,92vw)] rounded-xl shadow-2xl p-5">
          <h4 class="font-bold mb-2">{{ uiT('company.confirmTitle') }}</h4>
          <p class="text-sm text-gray-600 mb-4">{{ uiT('company.confirmSave') }}</p>
          <div class="flex justify-end gap-3">
            <button class="px-3 py-1.5 rounded border" @click="confirming=false">{{ uiT('company.no') }}</button>
            <button class="px-3 py-1.5 rounded bg-blue-600 text-white" @click="doSave">{{ uiT('common.yesSave') }}</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { inject, ref, defineProps } from 'vue';
  import { useToast } from "vue-toastification";
  import { getUserManagementLanguage, translateUserManagement } from "./i18n/userManagementI18n.js";
  
const toast = useToast();
const userManagementI18n = inject('userManagementI18n', null);
const uiT = (key, params = {}) => userManagementI18n?.t
  ? userManagementI18n.t(key, params)
  : translateUserManagement(getUserManagementLanguage(), key, params);

  
  const props = defineProps({
    groupId: { type: [Number, String], default: null },
    groupToken: { type: String, default: null }
  });
  
  const open = ref(false);
  const loading = ref(false);
  const confirming = ref(false);
  
  const form = ref({
    tipo_identificacion: null,
    numero_identificacion: null,
    razon_social: null,
    pais: null,
    ciudad: null,
    direccion: null,
    telefono: null,
    moneda: null,
    pagina_web: null,
    celular: null,
    correo_electronico: null,
    nombre_representante_legal: null,
    identificacion_representante_legal: null,
    cargo_representante_legal: null
  });
  
  function openModal() {
    open.value = true;
    fetchData();
  }
  function close() {
    open.value = false;
  }
  
  async function fetchData() {
    loading.value = true;
    const qs = props.groupId ? `group_id=${props.groupId}` : `token=${encodeURIComponent(props.groupToken)}`;
    const res = await fetch(`/api/detalle-empresa/show?${qs}`);
    const data = await res.json();
    if (data?.ok && data.detalle) {
      // merge conservando nulls
      Object.assign(form.value, data.detalle);
    }else {
      toast.info(uiT('company.noPreviousData'));
    }
    loading.value = false;
  }
  
  function confirmSave() {
    confirming.value = true;
  }
  async function doSave() {
    confirming.value = false;
    const payload = {
      ...(props.groupId ? { group_id_token: props.groupId } : { token: props.groupToken }),
      ...form.value
    };
    const res = await fetch('/api/detalle-empresa/update', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (data?.ok) {
      // opcional: toast
      
      toast.success(uiT('company.updated'));
      close();
    } else {
      alert(uiT('company.unableToSave'));
    }
  }
  </script>
  
